module.exports = __webpack_public_path__ + "img/mandarin-2.e454e37e.png";